/** Roamler-branded color palette for inline chat charts (ChatMarkdown). */
export const CHART_COLORS = [
  '#ff6738',
  '#f47835',
  '#fecda5',
  '#22c55e',
  '#eab308',
  '#14b8a6',
  '#ef4444',
  '#8b5cf6',
  '#ec4899',
  '#6366f1',
];

/** API endpoint paths. */
export const API = {
  CHAT_SESSIONS: '/api/chat/sessions',
  CHAT_AGENTS: '/api/chat/agents',
  CHAT_MODELS: '/api/chat/models',
  CHAT_SEND: '/api/chat/send',
  CHAT_UPLOAD: '/api/chat/upload',
  USERS: '/api/users',
  EVAL_SEARCH_DATASETS: '/api/evaluation/search-datasets',
  EVAL_SEARCH_RUNS: '/api/evaluation/search-eval/runs',
  EVAL_SEARCH_START: '/api/evaluation/search-eval/start',
} as const;

/** Helpers to build paths with dynamic segments. */
export const apiPath = {
  chatSession: (sessionId: string) => `${API.CHAT_SESSIONS}/${sessionId}`,
  chatSessionsAfter: (lastId: string) =>
    `${API.CHAT_SESSIONS}?after=${encodeURIComponent(lastId)}`,
  evalSearchRun: (runId: string) => `${API.EVAL_SEARCH_RUNS}/${runId}`,
  user: (email: string) => `${API.USERS}/${encodeURIComponent(email)}`,
  userCheckAuth: (email: string) =>
    `${API.USERS}/check-auth-method?email=${encodeURIComponent(email)}`,
};

/** Distinguishable multi-hue palette for charts and maps (Roamler orange first). */
export const CHART_COLORS_WARM = [
  '#ff6738',
  '#3b82f6',
  '#22c55e',
  '#f59e0b',
  '#8b5cf6',
  '#ec4899',
  '#06b6d4',
  '#ef4444',
  '#84cc16',
  '#f97316',
];
